import {cn} from '@cohort/shared-frontend/utils/classNames';
import {RadioGroup} from '@headlessui/react';
import React from 'react';

export interface SegmentedControlOption {
  value: string;
  label?: string;
  testId?: string;
  icon?: React.ReactNode;
}

interface SegmentedControlProps {
  options: SegmentedControlOption[];
  currentOption: SegmentedControlOption;
  onChange: (value: SegmentedControlOption) => void;
}

export const SegmentedControl: React.FC<SegmentedControlProps> = ({
  options,
  currentOption,
  onChange,
}) => {
  return (
    <RadioGroup
      value={currentOption}
      onChange={(option: SegmentedControlOption) => onChange(option)}
      className="flex space-x-1 rounded-lg bg-slate-100 p-0.5"
    >
      {options.map(option => (
        <RadioGroup.Option
          key={option.value}
          value={option}
          data-testid={option.testId}
          className={cn(
            'flex cursor-pointer items-center rounded-md py-[0.4375rem] pl-2 pr-2 text-sm font-semibold',
            option.value === currentOption.value ? 'bg-white   shadow' : 'text-slate-600'
          )}
        >
          <div
            className={cn(option.value === currentOption.value ? 'text-primary' : 'text-slate-400')}
          >
            {option.icon}
          </div>
          {option.label !== undefined && (
            <span className="ml-2" data-testid={option.testId}>
              {option.label}
            </span>
          )}
        </RadioGroup.Option>
      ))}
    </RadioGroup>
  );
};
SegmentedControl.displayName = 'SegmentedControl';
